import React from 'react'
import ChronosHourglass from '../../assets/svg/hourglass.svg'
import styled, { keyframes, css } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const StyledSVG = styled.svg<{ size: string; stroke?: string }>`
  animation: 2s ${rotate} linear infinite;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  path {
    stroke: ${({ stroke, theme }) => stroke ?? theme.primary1};
  }
`

/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */
export default function Loader({
  size = '16px',
  stroke,
  ...rest
}: {
  size?: string
  stroke?: string
  [k: string]: any
}) {
  return (
    <StyledSVG viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" size={size} stroke={stroke} {...rest}>
      <g clipPath="url(#clip0_343_33872)">
        <path
          d="M58.3761 29.9856V29.9568C58.3761 14.28 45.6213 1.52399 29.9445 1.52399C14.2677 1.52399 1.51172 14.28 1.51172 29.9568C1.51172 45.6336 14.2665 58.3884 29.9445 58.3884C45.5925 58.3884 58.3281 45.6816 58.3761 30.0444V29.9856ZM56.6265 30.0444C56.622 32.1507 56.2083 34.2362 55.4085 36.1848H45.7581C47.4978 35.4845 49.0512 34.3901 50.2962 32.9876C51.5412 31.5852 52.4437 29.9129 52.9328 28.1025C53.422 26.2921 53.4843 24.3928 53.1149 22.5542C52.7455 20.7156 51.9545 18.9878 50.8041 17.5068C52.6263 19.0362 54.0918 20.946 55.0976 23.1019C56.1034 25.2578 56.6253 27.6078 56.6265 29.9868V30.0444ZM43.6581 26.9244C43.6591 27.5989 43.4599 28.2585 43.0859 28.8197C42.7119 29.381 42.1798 29.8187 41.5569 30.0775C40.934 30.3363 40.2484 30.4045 39.5868 30.2735C38.9251 30.1425 38.3172 29.8181 37.84 29.3416C37.3627 28.865 37.0375 28.2575 36.9056 27.5961C36.7736 26.9346 36.8409 26.2489 37.0988 25.6257C37.3567 25.0024 37.7936 24.4697 38.3544 24.0949C38.9151 23.7201 39.5744 23.52 40.2489 23.52C41.153 23.5209 42.0198 23.8806 42.659 24.52C43.2981 25.1594 43.6575 26.0263 43.6581 26.9304V26.9244ZM35.0901 26.9244C35.0906 27.7296 35.2795 28.5236 35.6418 29.2428C36.0041 29.9619 36.5296 30.5863 37.1764 31.066C37.8232 31.5457 38.5733 31.8673 39.3666 32.0052C40.16 32.143 40.9746 32.0933 41.7453 31.86C41.029 32.4336 40.1856 32.8272 39.2859 33.0077C38.3862 33.1883 37.4562 33.1506 36.5741 32.8977C35.6919 32.6449 34.8832 32.1843 34.2157 31.5545C33.5482 30.9248 33.0414 30.1442 32.7377 29.2783C32.434 28.4123 32.3423 27.4861 32.4702 26.5774C32.5982 25.6687 32.942 24.8039 33.4731 24.0554C34.0041 23.307 34.7067 22.6967 35.5222 22.2758C36.3376 21.8548 37.242 21.6354 38.1597 21.636C38.6454 21.6356 39.1292 21.6965 39.5997 21.8172C38.3548 21.9754 37.2102 22.5818 36.3802 23.5229C35.5501 24.4641 35.0915 25.6755 35.0901 26.9304V26.9244ZM38.1873 34.8672C39.5983 34.8631 40.9795 34.4608 42.172 33.7065C43.3644 32.9522 44.3197 31.8765 44.9279 30.6033C45.536 29.3301 45.7724 27.9111 45.6098 26.5095C45.4471 25.1079 44.8921 23.7806 44.0085 22.6805C43.125 21.5804 41.9488 20.7521 40.6153 20.2909C39.2818 19.8297 37.8452 19.7543 36.4707 20.0734C35.0963 20.3926 33.8399 21.0932 32.846 22.0948C31.8522 23.0965 31.1613 24.3583 30.8529 25.7352C30.8325 25.4676 30.8193 25.1988 30.8193 24.9264C30.8188 22.7398 31.508 20.6088 32.7887 18.8365C34.0694 17.0643 35.8765 15.7411 37.9527 15.0553C40.0289 14.3694 42.2686 14.3559 44.353 15.0166C46.4373 15.6773 48.2602 16.9786 49.5623 18.7353C50.8643 20.4919 51.5791 22.6145 51.605 24.8009C51.6309 26.9874 50.9665 29.1263 49.7065 30.9133C48.4464 32.7003 46.6548 34.0444 44.5867 34.7542C42.5186 35.4641 40.2792 35.5036 38.1873 34.8672ZM29.0673 24.9264C29.0703 27.3442 29.7941 29.7063 31.1463 31.7107C32.4985 33.715 34.4177 35.2707 36.6585 36.1788H25.1613C24.3558 34.2184 23.9416 32.1194 23.9421 30C23.9421 22.8864 28.5129 16.824 34.8693 14.5836C33.0983 15.6686 31.6351 17.1897 30.6197 19.0015C29.6043 20.8134 29.0707 22.8554 29.0697 24.9324L29.0673 24.9264ZM39.4077 37.9284V46.32C36.6468 46.169 33.9693 45.3209 31.625 43.8546C29.2808 42.3884 27.3464 40.352 26.0025 37.9356L39.4077 37.9284ZM41.1573 37.9284H54.5649C53.2219 40.3462 51.2879 42.384 48.9436 43.8515C46.5993 45.319 43.9213 46.1683 41.1597 46.32L41.1573 37.9284ZM29.9445 56.64C15.2313 56.64 3.26132 44.6688 3.26132 29.9568C3.26132 15.2448 15.2313 3.27359 29.9445 3.27359C40.3461 3.27359 49.3749 9.25679 53.7741 17.9616C52.0805 16.0574 50.0029 14.5336 47.6779 13.4903C45.3529 12.447 42.8333 11.908 40.2849 11.9088C30.3093 11.9088 22.1997 20.0244 22.1997 30C22.1997 39.9756 30.3153 48.0924 40.2909 48.0924C42.812 48.0933 45.3054 47.5661 47.6103 46.5447C49.9152 45.5233 51.9806 44.0303 53.6733 42.162C49.2297 50.7528 40.2621 56.64 29.9445 56.64Z"
          fill="url(#paint0_linear_343_33872)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_343_33872"
          x1="2.62235"
          y1="52.3186"
          x2="65.2661"
          y2="26.4343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F4AB3" />
          <stop offset="1" stopColor="#7A64D0" />
        </linearGradient>
        <clipPath id="clip0_343_33872">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </StyledSVG>
  )
}

const pulse = keyframes`
  0% { transform: scale(1); }
  60% { transform: scale(1.1); }
  100% { transform: scale(1); }
`

const Wrapper = styled.div<{ fill: number; height?: string }>`
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, fill }) => (fill ? 'black' : theme.bg0)};
  height: 100%;
  width: 100%;
  ${(props) =>
    props.fill && !props.height
      ? css`
          height: 100vh;
        `
      : css`
          height: 180px;
        `}
`

const AnimatedImg = styled.div`
  animation: ${pulse} 800ms linear infinite;
  & > * {
    width: 72px;
  }
`

export const LocalLoader = ({ fill }: { fill: boolean }) => {
  return (
    <Wrapper fill={fill ? 1 : 0}>
      <AnimatedImg>
        <img src={ChronosHourglass} alt="loading-icon" />
      </AnimatedImg>
    </Wrapper>
  )
}

const loadingAnimation = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

export const LoadingRows = styled.div`
  display: grid;
  min-width: 75%;
  max-width: 100%;
  grid-column-gap: 0.5em;
  grid-row-gap: 0.8em;
  grid-template-columns: repeat(1, 1fr);
  & > div {
    animation: ${loadingAnimation} 1.5s infinite;
    animation-fill-mode: both;
    background: linear-gradient(
      to left,
      ${({ theme }) => theme.bg1} 25%,
      ${({ theme }) => theme.bg2} 50%,
      ${({ theme }) => theme.bg1} 75%
    );
    background-size: 400%;
    border-radius: 12px;
    height: 2.4em;
    will-change: background-position;
  }
  & > div:nth-child(4n + 1) {
    grid-column: 1 / 3;
  }
  & > div:nth-child(4n) {
    grid-column: 3 / 4;
    margin-bottom: 2em;
  }
`
